/**
 * The four brands that make the write doors unforgeable.
 *
 * Deliberately **not** re-exported from `index.ts`. A caller outside this
 * package cannot name these symbols, so it cannot construct a `BindingAuthority`,
 * an `EditorAuthority` or a `Grant` — which is the difference between "writes
 * are checked" and "writes are unreachable except through a check".
 */

export const WRITABLE: unique symbol = Symbol('morph.store.writable');
export const EDITOR: unique symbol = Symbol('morph.store.editor');
export const GRANT: unique symbol = Symbol('morph.store.grant');
/** A relation target. Decision 0016: the target of `link`/`unlink` travels as
 *  an opaque, store-minted handle that *"may not be constructed from typed
 *  text"* — so it carries a brand for the same reason a grant does, and holds
 *  a token this store can resolve rather than the object's own id. */
export const RELATION_TARGET: unique symbol = Symbol('morph.store.relationTarget');
